<template>
  <div>
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime las Facturas Pendientes por Cobrar de Clientes.'"
          :titulo="'Reporte Depósito Facturas al Cobro'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReporteDepositoFacturas'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!-- Formulario-Deposito Facturas al Cobro -->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">Reporte Depósito Facturas al Cobro</span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="DepositoFacturas.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- -----------------------------  Cliente  -->
                        <v-combobox
                          v-model="DepositoFacturas.cliente"
                          :items="Rcliente"
                          autocomplete="off"
                          dense
                          item-text="codnom"
                          label="Cliente:"
                          no-filter
                          outlined
                          @blur="SelctCbClient"
                          @focus="cargarCliente"
                          @keyup="CbFilcliente"
                        >
                          <template slot="item" slot-scope="item">
                            <span style="display: none">
                              {{ (item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `) }}
                            </span>
                            <span class="fontSize13">
                              <b>{{ item.item.codigo }}</b>
                              - {{ item.item.nombre.trim() }}
                            </span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span class="fontSize13 colorNombre">
                              <b>{{ item.codigo }}</b>
                              - {{ item.nombre.trim() }}
                            </span>
                          </template>

                          <template v-slot:prepend>
                            <i class="fa fa-user-circle-o" style="font-size: 30px"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="DepositoFacturas.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!------------------------------- Tipo de Cliente -->
                        <v-combobox
                          v-model="DepositoFacturas.tipocliente"
                          :items="RtipoCliente"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Tipo de Cliente:"
                          outlined
                          @blur="SelctCbTipoCliente"
                          @focus="cargarTipoCliente"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <!--- Subtipo de Cliente --->
                        <v-autocomplete
                          v-model="DepositoFacturas.subtipoCliente"
                          :items="
                            DepositoFacturas.tipocliente
                              ? DepositoFacturas.tipocliente.subtipos
                              : DepositoFacturas.subtipo || []
                          "
                          clearable
                          dense
                          item-text="descripcion"
                          label="Subtipo"
                          outlined
                          return-object
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros :Datos="DepositoFacturas" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Deposito Facturas al Cobro -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Reporte Depósito Facturas al Cobro",
        descripcion: "Imprime las Facturas Pendientes por Cobrar de Clientes.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReporteDepositoFacturasNew",
          "ReporteDepositoFacturasSave",
          "ReporteDepositoFacturasRemove",
          "ReporteDepositoFacturasAnular",
          "ReporteDepositoFacturasPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("ReporteDepositoFacturasNew", this.new);
      // EventBus.$on("ReporteDepositoFacturasSave", this.save);
      // EventBus.$on("ReporteDepositoFacturasRemove", this.remove);
      // EventBus.$on("ReporteDepositoFacturasAnular", this.remove);
      // EventBus.$on("ReporteDepositoFacturasPrintList", this.imprimirList);
      // EventBus.$on("emitReporteDepositoFacturas", this.datostabla);
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      Rpropietario: [],
      RCaja: [],
      RtipoCliente: [],
      Rcliente: [],

      windowSize: { width: "auto", height: "auto" },
      DepositoFacturas: {
        nombre: "Deposito Facturas al Cobro",
        UrlImprimir: "/reportescxc/ImprimirDepoFactCobro",
        UrlExel: "/reportescxc/ExcelDepoFactCobro",
        UrlCorreo: "/reportescxc/Correo",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        cliente: null,
        tipocliente: null,
        subtipoCliente: null,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,

      onResize(e) {
        console.log("imprii ")

        console.log(e)
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {},
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      // Retorna los datos del componente ModalReporteFiltros
      DDataReporteBasico() {},
      newwnuevo() {
        ;(this.DepositoFacturas = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      // Un método que se llama cuando la entrada pierde el foco y valida
      //si el objeto es nulo, si lo es coloca la fecha actual.
      BlurDesde() {
        if (this.DepositoFacturas.desde.toString().length == 0) {
          this.DepositoFacturas.desde = this.fechaNueva()
        }
      },

      // Un método que se llama cuando la entrada pierde el foco y valida
      //si el objeto es nulo, si lo es coloca la fecha actual.
      BlurHasta() {
        if (this.DepositoFacturas.hasta.toString().length == 0) {
          this.DepositoFacturas.hasta = this.fechaNueva()
        }
      },

      // Llamar a una API y obtener los datos.
      cargarCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.Rcliente = res.data))
      },

      // Hacer una solicitud al servidor y devolver los datos al cliente.
      CbFilcliente(e) {
        if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => (this.Rcliente = res.data))
        }
      },

      // Comprobando si el cliente es nulo o indefinido.
      SelctCbClient() {
        if (this.DepositoFacturas.cliente == null) {
          this.DepositoFacturas.cliente = ""
        }

        if (this.DepositoFacturas.cliente.codigo == undefined) {
          this.alerta("Seleccione un cliente", "error")
          this.DepositoFacturas.cliente = ""
          return
        }
      },

      // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RtipoCliente.
      cargarTipoCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => (this.RtipoCliente = res.data))
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbTipoCliente() {
        if (this.DepositoFacturas.tipocliente == null) {
          this.DepositoFacturas.tipocliente = ""
        }

        if (this.DepositoFacturas.tipocliente.codigo == undefined) {
          this.alerta("Seleccione un tipo de cliente", "error")
          this.DepositoFacturas.tipocliente = ""
          return
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },
    },
  }
</script>

<style></style>
